(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-menu-lines-professional"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-kf-navigation]';
  var resizePending = false;

  function clamp(value, minimum, maximum) {
    return Math.max(minimum, Math.min(value, maximum));
  }

  function maxScroll(viewport) {
    return Math.max(0, viewport.scrollWidth - viewport.clientWidth);
  }

  function prefersReducedMotion() {
    return !!(window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function activePosition(viewport, link) {
    var parent = viewport.getBoundingClientRect();
    var child = link.getBoundingClientRect();
    var center = viewport.scrollLeft + child.left - parent.left + child.width / 2;
    return Math.round(clamp(center - viewport.clientWidth / 2, 0, maxScroll(viewport)));
  }

  function readSavedPosition(key) {
    try {
      var value = window.sessionStorage.getItem(key);
      if (value === null) return null;
      window.sessionStorage.removeItem(key);
      var parsed = Number(value);
      return Number.isFinite(parsed) ? parsed : null;
    } catch (error) {
      return null;
    }
  }

  function savePosition(key, position) {
    try {
      window.sessionStorage.setItem(key, String(Math.round(position)));
    } catch (error) {
      // Navigation remains functional when storage is unavailable.
    }
  }

  function isPlainPrimaryPointer(event) {
    return (event.button === undefined || event.button === 0) &&
      !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey;
  }

  function updateControls(root, viewport) {
    if (!root.isConnected || !viewport) return;
    var maximum = maxScroll(viewport);
    var position = clamp(viewport.scrollLeft, 0, maximum);
    var canScrollLeft = maximum > 2 && position > 2;
    var canScrollRight = maximum > 2 && position < maximum - 2;
    root.classList.toggle('has-kf-overflow-left', canScrollLeft);
    root.classList.toggle('has-kf-overflow-right', canScrollRight);
    var previous = root.querySelector('[data-kf-scroll-previous]');
    var next = root.querySelector('[data-kf-scroll-next]');
    if (previous) previous.disabled = !canScrollLeft;
    if (next) next.disabled = !canScrollRight;
  }

  function scheduleUpdate(root, viewport) {
    if (root.dataset.kfOverflowUpdatePending === 'true') return;
    root.dataset.kfOverflowUpdatePending = 'true';
    window.requestAnimationFrame(function () {
      root.dataset.kfOverflowUpdatePending = 'false';
      updateControls(root, viewport);
    });
  }

  function scrollViewport(viewport, position, smooth) {
    var target = Math.round(clamp(position, 0, maxScroll(viewport)));
    if (smooth && !prefersReducedMotion() && viewport.scrollTo) {
      viewport.scrollTo({ left: target, behavior: 'smooth' });
    } else {
      viewport.scrollLeft = target;
    }
  }

  function safeNavigationTarget(value) {
    if (!value) return null;
    try {
      var url = new URL(value, window.location.href);
      var protocol = url.protocol.toLowerCase();
      if (protocol === 'https:' || protocol === 'http:' ||
          protocol === 'mailto:' || protocol === 'tel:') {
        return url.href;
      }
    } catch (error) {
      // Ignore malformed or unsafe navigation targets.
    }
    return null;
  }

  function initNavigation(root) {
    if (!root || root.dataset.kfInitialized === 'true') return;
    var viewport = root.querySelector('[data-kf-viewport]');
    if (!viewport) return;
    root.dataset.kfInitialized = 'true';

    var select = root.querySelector('[data-kf-select]');
    var active = root.querySelector('[data-kf-active-filter]');
    var sectionId = root.dataset.kfSectionId || root.id;
    var storageKey = 'kf-filter-position-' + sectionId;
    var pointerStartPosition = null;
    var savedPosition = readSavedPosition(storageKey);

    if (select) {
      select.addEventListener('change', function () {
        var target = safeNavigationTarget(select.value);
        if (target) window.location.assign(target);
      });
    }

    // Keep the previously visible menu position stable across page changes.
    // Move to the newly active item in one native horizontal animation only.
    var userInteracted = false;
    var autoAligning = false;
    function stopAutomaticAlignment() {
      userInteracted = true;
      if (!autoAligning) return;
      autoAligning = false;
      // Stop only an active automatic animation, never ordinary finger momentum.
      if (viewport.scrollTo) {
        viewport.scrollTo({ left: viewport.scrollLeft, behavior: 'instant' });
      }
    }
    viewport.addEventListener('scrollend', function () { autoAligning = false; }, { passive: true });
    viewport.addEventListener('pointerdown', stopAutomaticAlignment, { passive: true });
    viewport.addEventListener('wheel', stopAutomaticAlignment, { passive: true });
    viewport.addEventListener('keydown', stopAutomaticAlignment);

    if (savedPosition !== null) {
      scrollViewport(viewport, savedPosition, false);
    } else if (active) {
      scrollViewport(viewport, activePosition(viewport, active), false);
    }
    updateControls(root, viewport);

    if (savedPosition !== null && active && prefersReducedMotion()) {
      scrollViewport(viewport, activePosition(viewport, active), false);
      updateControls(root, viewport);
    } else if (savedPosition !== null && active) {
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          if (!root.isConnected || userInteracted) return;
          var destination = activePosition(viewport, active);
          if (Math.abs(destination - viewport.scrollLeft) > 2) {
            autoAligning = true;
            scrollViewport(viewport, destination, true);
          }
        });
      });
    }

    viewport.addEventListener('scroll', function () {
      scheduleUpdate(root, viewport);
    }, { passive: true });

    root.addEventListener('click', function (event) {
      var target = event.target;
      var control = target && target.closest ? target.closest('[data-kf-scroll-control]') : null;
      if (control && root.contains(control) && !control.disabled) {
        event.preventDefault();
        var direction = Number(control.getAttribute('data-kf-scroll-direction'));
        if (direction !== 1 && direction !== -1) return;
        var distance = Math.max(180, Math.round(viewport.clientWidth * 0.72));
        scrollViewport(viewport, viewport.scrollLeft + direction * distance, true);
        scheduleUpdate(root, viewport);
        return;
      }

      var link = target && target.closest ? target.closest('.kf-filter-link') : null;
      if (!link || !root.contains(link) || !link.hasAttribute('href') ||
          event.defaultPrevented || !isPlainPrimaryPointer(event)) return;
      savePosition(storageKey,
        pointerStartPosition !== null ? pointerStartPosition : viewport.scrollLeft);
      pointerStartPosition = null;
    });

    root.addEventListener('pointerdown', function (event) {
      var target = event.target;
      var link = target && target.closest ? target.closest('.kf-filter-link') : null;
      if (link && root.contains(link) && link.hasAttribute('href') &&
          isPlainPrimaryPointer(event)) {
        pointerStartPosition = viewport.scrollLeft;
      }
    }, { passive: true });

    root.addEventListener('mousedown', function (event) {
      var target = event.target;
      var link = target && target.closest ? target.closest('.kf-filter-link') : null;
      if (link && root.contains(link) && link.hasAttribute('href') &&
          isPlainPrimaryPointer(event)) {
        // Prevent native mouse focus from moving the scroll position before click.
        event.preventDefault();
      }
    });

    // Font/layout changes only refresh arrow availability; never force another
    // scroll animation after the visitor has started swiping.
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        updateControls(root, viewport);
      }).catch(function () {
        // Font loading failure does not affect the navigation links.
      });
    }
  }

  function scan(scope) {
    var target = scope || document;
    if (target.nodeType === 1 && target.matches && target.matches(ROOT_SELECTOR)) {
      initNavigation(target);
    }
    if (target.querySelectorAll) target.querySelectorAll(ROOT_SELECTOR).forEach(initNavigation);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scan(document);
    }, { once: true });
  } else {
    scan(document);
  }

  window.addEventListener('resize', function () {
    if (resizePending) return;
    resizePending = true;
    window.requestAnimationFrame(function () {
      resizePending = false;
      document.querySelectorAll(ROOT_SELECTOR).forEach(function (root) {
        var viewport = root.querySelector('[data-kf-viewport]');
        if (viewport) updateControls(root, viewport);
      });
    });
  }, { passive: true });

  document.addEventListener('shopify:section:load', function (event) {
    scan(event.target);
  });
  document.addEventListener('shopify:section:select', function (event) {
    scan(event.target);
  });
  document.addEventListener('shopify:block:select', function (event) {
    var block = event.target;
    if (!block || !block.closest) return;
    var root = block.closest(ROOT_SELECTOR);
    if (!root) return;
    scan(root);
    var viewport = root.querySelector('[data-kf-viewport]');
    if (viewport && block.matches('.kf-filter-link')) {
      // Scroll only the navigation viewport, not the whole storefront page.
      scrollViewport(viewport, activePosition(viewport, block), false);
      updateControls(root, viewport);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tag-blog-menu"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-kf-blog-tag-navigation]';

  function clamp(number, min, max) {
    return Math.max(min, Math.min(number, max));
  }

  function maxScroll(viewport) {
    return Math.max(0, viewport.scrollWidth - viewport.clientWidth);
  }

  function positionOfActive(viewport, active) {
    var viewportBox = viewport.getBoundingClientRect();
    var activeBox = active.getBoundingClientRect();
    var center = viewport.scrollLeft + activeBox.left - viewportBox.left + activeBox.width / 2;
    return Math.round(clamp(center - viewport.clientWidth / 2, 0, maxScroll(viewport)));
  }

  function takeSavedPosition(key) {
    try {
      var stored = window.sessionStorage.getItem(key);
      if (stored === null) return null;
      window.sessionStorage.removeItem(key);
      var position = Number(stored);
      return Number.isFinite(position) ? position : null;
    } catch (error) {
      return null;
    }
  }

  function savePosition(key, position) {
    try {
      window.sessionStorage.setItem(key, String(Math.round(position)));
    } catch (error) {
      // Native navigation still works if storage is blocked.
    }
  }

  function isNormalClick(event) {
    return (event.button === undefined || event.button === 0) &&
      !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey;
  }

  function reducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function cleanTaggedTitle(root) {
    if (root.dataset.kfCleanTagTitle !== 'true' || !document.title) return;
    var cleanedTitle = document.title
      .replace(/\btagged\s*["“”']?/i, '')
      .replace(/["“”'](?=\s*(?:[-–—]\s*|$))/i, '')
      .replace(/\s{2,}/g, ' ')
      .trim();
    if (cleanedTitle) document.title = cleanedTitle;
  }

  function init(root) {
    if (!root || root.dataset.kfTagNavigationInitialized === 'true') return;
    var viewport = root.querySelector('[data-kf-tag-viewport]');
    if (!viewport) return;
    root.dataset.kfTagNavigationInitialized = 'true';

    var previous = root.querySelector('[data-kf-tag-previous]');
    var next = root.querySelector('[data-kf-tag-next]');
    var active = root.querySelector('[data-kf-tag-active]');
    var key = 'kf-tag-navigation-position-' + (root.dataset.kfTagSectionId || root.id);
    var saved = takeSavedPosition(key);
    var pointerStart = null;
    var pending = false;

    cleanTaggedTitle(root);

    function updateControls() {
      var maximum = maxScroll(viewport);
      var current = clamp(viewport.scrollLeft, 0, maximum);
      var left = maximum > 2 && current > 2;
      var right = maximum > 2 && current < maximum - 2;
      root.classList.toggle('has-kf-tag-overflow-left', left);
      root.classList.toggle('has-kf-tag-overflow-right', right);
      if (previous) previous.disabled = !left;
      if (next) next.disabled = !right;
    }

    function queueUpdate() {
      if (pending) return;
      pending = true;
      window.requestAnimationFrame(function () {
        pending = false;
        if (root.isConnected) updateControls();
      });
    }

    viewport.addEventListener('scroll', queueUpdate, { passive: true });

    root.addEventListener('click', function (event) {
      var target = event.target;
      var control = target && target.closest ? target.closest('[data-kf-tag-control]') : null;
      if (control && root.contains(control)) {
        if (control.disabled) return;
        event.preventDefault();
        var direction = Number(control.getAttribute('data-kf-tag-direction'));
        if (direction !== 1 && direction !== -1) return;
        var distance = Math.max(180, Math.round(viewport.clientWidth * 0.72));
        var position = Math.round(clamp(viewport.scrollLeft + direction * distance, 0, maxScroll(viewport)));
        if (typeof viewport.scrollTo === 'function' && !reducedMotion()) {
          viewport.scrollTo({ left: position, behavior: 'smooth' });
        } else {
          viewport.scrollLeft = position;
        }
        queueUpdate();
        return;
      }

      var link = target && target.closest ? target.closest('.kf-tag-navigation__link') : null;
      if (!link || !root.contains(link) || event.defaultPrevented || !isNormalClick(event)) return;
      savePosition(key, pointerStart !== null ? pointerStart : viewport.scrollLeft);
      pointerStart = null;
    });

    root.addEventListener('pointerdown', function (event) {
      var target = event.target;
      var link = target && target.closest ? target.closest('.kf-tag-navigation__link') : null;
      if (link && root.contains(link) && isNormalClick(event)) {
        pointerStart = viewport.scrollLeft;
      }
    }, { passive: true });

    root.addEventListener('pointercancel', function () { pointerStart = null; }, { passive: true });

    root.addEventListener('mousedown', function (event) {
      if (!window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
      var target = event.target;
      var link = target && target.closest ? target.closest('.kf-tag-navigation__link') : null;
      if (link && root.contains(link) && isNormalClick(event)) {
        // A mouse focus change must not pull the document or scroller suddenly.
        event.preventDefault();
      }
    });

    // Restore the previous view, then align the newly selected tag exactly once.
    // Only this horizontal viewport moves; never scroll the document itself.
    var userInteracted = false;
    var autoAligning = false;
    function stopAutomaticAlignment() {
      userInteracted = true;
      if (!autoAligning) return;
      autoAligning = false;
      if (viewport.scrollTo) {
        viewport.scrollTo({ left: viewport.scrollLeft, behavior: 'instant' });
      }
    }
    viewport.addEventListener('scrollend', function () { autoAligning = false; }, { passive: true });
    viewport.addEventListener('pointerdown', stopAutomaticAlignment, { passive: true });
    viewport.addEventListener('wheel', stopAutomaticAlignment, { passive: true });
    viewport.addEventListener('keydown', stopAutomaticAlignment);

    function initialPosition() {
      if (!root.isConnected || userInteracted) return;
      var maximum = maxScroll(viewport);
      if (saved !== null) {
        viewport.scrollLeft = Math.round(clamp(saved, 0, maximum));
      } else if (active && maximum > 0) {
        viewport.scrollLeft = positionOfActive(viewport, active);
      }
      updateControls();

      if (saved !== null && active && !reducedMotion()) {
        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(function () {
            if (!root.isConnected || userInteracted) return;
            var target = positionOfActive(viewport, active);
            if (Math.abs(target - viewport.scrollLeft) > 2) {
              if (typeof viewport.scrollTo === 'function') {
                autoAligning = true;
                viewport.scrollTo({ left: target, behavior: 'smooth' });
              } else {
                viewport.scrollLeft = target;
              }
            }
          });
        });
      } else if (saved !== null && active && !userInteracted) {
        // Honor reduced-motion without introducing an animated movement.
        viewport.scrollLeft = positionOfActive(viewport, active);
      }
      saved = null;
    }

    window.requestAnimationFrame(initialPosition);

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(queueUpdate).catch(queueUpdate);
    }
  }

  function scan(scope) {
    var target = scope || document;
    if (target.nodeType === 1 && target.matches && target.matches(ROOT_SELECTOR)) init(target);
    if (target.querySelectorAll) target.querySelectorAll(ROOT_SELECTOR).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(document); }, { once: true });
  } else {
    scan(document);
  }

  var resizePending = false;
  window.addEventListener('resize', function () {
    if (resizePending) return;
    resizePending = true;
    window.requestAnimationFrame(function () {
      resizePending = false;
      document.querySelectorAll(ROOT_SELECTOR).forEach(function (root) {
        var viewport = root.querySelector('[data-kf-tag-viewport]');
        if (!viewport) return;
        var maximum = maxScroll(viewport);
        var current = clamp(viewport.scrollLeft, 0, maximum);
        var left = maximum > 2 && current > 2;
        var right = maximum > 2 && current < maximum - 2;
        root.classList.toggle('has-kf-tag-overflow-left', left);
        root.classList.toggle('has-kf-tag-overflow-right', right);
        var previous = root.querySelector('[data-kf-tag-previous]');
        var next = root.querySelector('[data-kf-tag-next]');
        if (previous) previous.disabled = !left;
        if (next) next.disabled = !right;
      });
    });
  }, { passive: true });

  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
  document.addEventListener('shopify:section:select', function (event) { scan(event.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tag-collection-menu"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-kf-collection-tag-navigation]';

  function clamp(number, min, max) {
    return Math.max(min, Math.min(number, max));
  }

  function maxScroll(viewport) {
    return Math.max(0, viewport.scrollWidth - viewport.clientWidth);
  }

  function positionOfActive(viewport, active) {
    var viewportBox = viewport.getBoundingClientRect();
    var activeBox = active.getBoundingClientRect();
    var center = viewport.scrollLeft + activeBox.left - viewportBox.left + activeBox.width / 2;
    return Math.round(clamp(center - viewport.clientWidth / 2, 0, maxScroll(viewport)));
  }

  function takeSavedPosition(key) {
    try {
      var stored = window.sessionStorage.getItem(key);
      if (stored === null) return null;
      window.sessionStorage.removeItem(key);
      var position = Number(stored);
      return Number.isFinite(position) ? position : null;
    } catch (error) {
      return null;
    }
  }

  function savePosition(key, position) {
    try {
      window.sessionStorage.setItem(key, String(Math.round(position)));
    } catch (error) {
      // Native navigation still works if storage is blocked.
    }
  }

  function isNormalClick(event) {
    return (event.button === undefined || event.button === 0) &&
      !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey;
  }

  function reducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function cleanTaggedTitle(root) {
    if (root.dataset.kfCleanTagTitle !== 'true' || !document.title) return;
    var cleanedTitle = document.title
      .replace(/\btagged\s*["“”']?/i, '')
      .replace(/["“”'](?=\s*(?:[-–—]\s*|$))/i, '')
      .replace(/\s{2,}/g, ' ')
      .trim();
    if (cleanedTitle) document.title = cleanedTitle;
  }

  function init(root) {
    if (!root || root.dataset.kfTagNavigationInitialized === 'true') return;
    var viewport = root.querySelector('[data-kf-tag-viewport]');
    if (!viewport) return;
    root.dataset.kfTagNavigationInitialized = 'true';

    var previous = root.querySelector('[data-kf-tag-previous]');
    var next = root.querySelector('[data-kf-tag-next]');
    var active = root.querySelector('[data-kf-tag-active]');
    var key = 'kf-tag-navigation-position-' + (root.dataset.kfTagSectionId || root.id);
    var saved = takeSavedPosition(key);
    var pointerStart = null;
    var pending = false;

    cleanTaggedTitle(root);

    function updateControls() {
      var maximum = maxScroll(viewport);
      var current = clamp(viewport.scrollLeft, 0, maximum);
      var left = maximum > 2 && current > 2;
      var right = maximum > 2 && current < maximum - 2;
      root.classList.toggle('has-kf-tag-overflow-left', left);
      root.classList.toggle('has-kf-tag-overflow-right', right);
      if (previous) previous.disabled = !left;
      if (next) next.disabled = !right;
    }

    function queueUpdate() {
      if (pending) return;
      pending = true;
      window.requestAnimationFrame(function () {
        pending = false;
        if (root.isConnected) updateControls();
      });
    }

    viewport.addEventListener('scroll', queueUpdate, { passive: true });

    root.addEventListener('click', function (event) {
      var target = event.target;
      var control = target && target.closest ? target.closest('[data-kf-tag-control]') : null;
      if (control && root.contains(control)) {
        if (control.disabled) return;
        event.preventDefault();
        var direction = Number(control.getAttribute('data-kf-tag-direction'));
        if (direction !== 1 && direction !== -1) return;
        var distance = Math.max(180, Math.round(viewport.clientWidth * 0.72));
        var position = Math.round(clamp(viewport.scrollLeft + direction * distance, 0, maxScroll(viewport)));
        if (typeof viewport.scrollTo === 'function' && !reducedMotion()) {
          viewport.scrollTo({ left: position, behavior: 'smooth' });
        } else {
          viewport.scrollLeft = position;
        }
        queueUpdate();
        return;
      }

      var link = target && target.closest ? target.closest('.kf-tag-navigation__link') : null;
      if (!link || !root.contains(link) || event.defaultPrevented || !isNormalClick(event)) return;
      savePosition(key, pointerStart !== null ? pointerStart : viewport.scrollLeft);
      pointerStart = null;
    });

    root.addEventListener('pointerdown', function (event) {
      var target = event.target;
      var link = target && target.closest ? target.closest('.kf-tag-navigation__link') : null;
      if (link && root.contains(link) && isNormalClick(event)) {
        pointerStart = viewport.scrollLeft;
      }
    }, { passive: true });

    root.addEventListener('pointercancel', function () { pointerStart = null; }, { passive: true });

    root.addEventListener('mousedown', function (event) {
      if (!window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
      var target = event.target;
      var link = target && target.closest ? target.closest('.kf-tag-navigation__link') : null;
      if (link && root.contains(link) && isNormalClick(event)) {
        // A mouse focus change must not pull the document or scroller suddenly.
        event.preventDefault();
      }
    });

    // Restore the previous view, then align the newly selected tag exactly once.
    // Only this horizontal viewport moves; never scroll the document itself.
    var userInteracted = false;
    var autoAligning = false;
    function stopAutomaticAlignment() {
      userInteracted = true;
      if (!autoAligning) return;
      autoAligning = false;
      if (viewport.scrollTo) {
        viewport.scrollTo({ left: viewport.scrollLeft, behavior: 'instant' });
      }
    }
    viewport.addEventListener('scrollend', function () { autoAligning = false; }, { passive: true });
    viewport.addEventListener('pointerdown', stopAutomaticAlignment, { passive: true });
    viewport.addEventListener('wheel', stopAutomaticAlignment, { passive: true });
    viewport.addEventListener('keydown', stopAutomaticAlignment);

    function initialPosition() {
      if (!root.isConnected || userInteracted) return;
      var maximum = maxScroll(viewport);
      if (saved !== null) {
        viewport.scrollLeft = Math.round(clamp(saved, 0, maximum));
      } else if (active && maximum > 0) {
        viewport.scrollLeft = positionOfActive(viewport, active);
      }
      updateControls();

      if (saved !== null && active && !reducedMotion()) {
        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(function () {
            if (!root.isConnected || userInteracted) return;
            var target = positionOfActive(viewport, active);
            if (Math.abs(target - viewport.scrollLeft) > 2) {
              if (typeof viewport.scrollTo === 'function') {
                autoAligning = true;
                viewport.scrollTo({ left: target, behavior: 'smooth' });
              } else {
                viewport.scrollLeft = target;
              }
            }
          });
        });
      } else if (saved !== null && active && !userInteracted) {
        // Honor reduced-motion without introducing an animated movement.
        viewport.scrollLeft = positionOfActive(viewport, active);
      }
      saved = null;
    }

    window.requestAnimationFrame(initialPosition);

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(queueUpdate).catch(queueUpdate);
    }
  }

  function scan(scope) {
    var target = scope || document;
    if (target.nodeType === 1 && target.matches && target.matches(ROOT_SELECTOR)) init(target);
    if (target.querySelectorAll) target.querySelectorAll(ROOT_SELECTOR).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(document); }, { once: true });
  } else {
    scan(document);
  }

  var resizePending = false;
  window.addEventListener('resize', function () {
    if (resizePending) return;
    resizePending = true;
    window.requestAnimationFrame(function () {
      resizePending = false;
      document.querySelectorAll(ROOT_SELECTOR).forEach(function (root) {
        var viewport = root.querySelector('[data-kf-tag-viewport]');
        if (!viewport) return;
        var maximum = maxScroll(viewport);
        var current = clamp(viewport.scrollLeft, 0, maximum);
        var left = maximum > 2 && current > 2;
        var right = maximum > 2 && current < maximum - 2;
        root.classList.toggle('has-kf-tag-overflow-left', left);
        root.classList.toggle('has-kf-tag-overflow-right', right);
        var previous = root.querySelector('[data-kf-tag-previous]');
        var next = root.querySelector('[data-kf-tag-next]');
        if (previous) previous.disabled = !left;
        if (next) next.disabled = !right;
      });
    });
  }, { passive: true });

  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
  document.addEventListener('shopify:section:select', function (event) { scan(event.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
